"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    ordering: {
        isFastOrderEnabled: 'fast-order-enabled',
        isLegacyOrderingOnline: 'legacy-ordering-online',
        isSignalREnabled: 'signalr-enabled',
        isOrderHistoryScreenEnabled: 'order-history-screen-enabled',
        isResilientFastOrderTopUpEnabled: 'up-resilient-fastorder-topup',
    },
    services: {
        isLegacyServicesOnline: 'legacy-services-online',
    },
    supplierService: {
        isSupplierRefundEnabled: 'enable-supplier-refunds',
        isItemsIframeEnabled: 'enable-supplier-items-iframe',
        enableFaasPrintAllLabels: 'enable-faas-print-all-labels',
        enableClassicReports: 'supplier-portal-classic-reports-enabled',
        enableItemsSummaryReport: 'supplier-portal-items-summary-report-enabled',
    },
    userPortal: {
        isResilientWalletTopUpEnabled: 'up-resilient-wallet-topup',
        enableSupplierLegacyRouting: 'enable-supplier-legacy-routing',
    },
    items: {
        itemManagementRoutingEnabled: 'frontend-item-management-routing-to-spv3-enabled',
    },
};
//# sourceMappingURL=FeatureFlagList.js.map